export default {
  install: (app, options) => {
    // sistema di traduzione delle stringhe in base al ruolo
    // al momento Stefano consiglia di non integrarlo finchè non si renderà indispensabile
    // ipotesi implementazione $acl(VALORE_DI_DEFAULT, LABEL_PATH(SEZIONE-WORD), ?PARAMETRI_NELLA_STRINGA)
    // EX. $acl('Lo Studio Notarile|{nome_studio} ha richiesto ..', 'checklist-dacompletare', null|{nome_studio: "Studio Notarile"})
    app.config.globalProperties.$acl = (defaultValue, snippet, params) => {
      // options.acl[binding.arg](binding.value) cerco quali tra i ruoli è quello attivo ?
      let snippetFounded = snippet.split('.').reduce((o, i) => {
        if (o) return o[i]
      }, options.snippets)

      if(params) {
        Object.keys(params).forEach((paramKey) => {
          if(snippetFounded.includes('{'+paramKey+'}')) {
            snippetFounded = snippetFounded.replace('{'+paramKey+'}', params[paramKey])
          }
        })
      }

      return snippetFounded;
    }

    if(["localhost", "locale", "test"].indexOf(window.location.host.split(".")[0]) > -1) {
      console.groupCollapsed('%c ACL: ruoli/permessi ', 'background: #c05328; color: #111');
      console.log(options.acl);
      console.groupEnd();
    }

    // direttiva che gestisce l' hide/show di elementi in base alla combo permessi/ruoli
    app.directive('acl', {
      beforeMount: function (element, binding, vnode) {
        if(!options.acl[binding.arg](binding.value)) {
          const observer = new MutationObserver((mutations, obs) => {
            if (element) {
              if(!binding.modifiers || Object.keys(binding.modifiers).length == 0) {
                commentNode(element, vnode)
              }

              if(binding.modifiers && binding.modifiers['disable'] != undefined) {
                element.disabled = true
              }

              obs.disconnect();
              return;
            }
          });

          observer.observe(document, {
            childList: true,
            subtree: true
          });
        }
      },
      unmounted: function (element) {

      }
    });
  },
}

/**
 * Sostituisce un elemento DOM con un Vue comment
 * @method commentNode
 * @param el
 * @param vnode
 */
function commentNode(el, vnode) {
  const comment = document.createComment(' ')

  Object.defineProperty(comment, 'setAttribute', {
    value: () => undefined
  })

  vnode.text = ' '
  vnode.elm = comment
  vnode.isComment = true
  vnode.context = undefined
  vnode.tag = undefined
  if(vnode['data'] != undefined && vnode.data['directives'] != undefined) {
    vnode.data.directives = undefined
  }

  if (vnode.componentInstance) {
    vnode.componentInstance.$el = comment
  }

  el.parentNode.replaceChild(comment, el)
}